import { render, staticRenderFns } from "./RecipientSidebar.vue?vue&type=template&id=a3f13ac8"
import script from "./RecipientSidebar.vue?vue&type=script&lang=js"
export * from "./RecipientSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports